import React from "react";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";
import Colors from "../theme/colors.json";

const useStyles = makeStyles((theme) => ({
  productButton: {
    margin: theme.spacing(1),
    fontSize: theme.fontSizes.SMALL,
  },
  inputLabel: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    fontWeight: "600",
    fontSize: theme.fontSizes.SMALL,
  },
  productFormFieldContainer: {
    padding: "0.9rem",
    borderRadius: "10px",
    background: Colors.WHITE_BACKGROUND,
  },
  productsBtnContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",
    fontSize: theme.fontSizes.SMALL,
  },
}));

const ProductsForm = ({ productCodes, handleProductCodeChange }) => {
  const classes = useStyles();

  return (
    <div className={classes.productFormFieldContainer}>
      <label className={classes.inputLabel}>Select The Product Title</label>
      <div className={classes.productsBtnContainer}>
        {productCodes.map((option) => (
          <Button
            key={option.productCode}
            className={classes.productButton}
            variant="outlined"
            color="primary"
            disabled={option.productStatus === "InActive"}
            onClick={() =>
              handleProductCodeChange({
                name: "productCode",
                value: option,
              })
            }
          >
            {option.productTitle}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default ProductsForm;
